import { v4 } from 'uuid';
import { HighlightsContainerRequest, HighlightsSectionRequest, SectionType } from '../model';

export function createSection(type: SectionType): HighlightsSectionRequest {
	return {
		newId: v4(),
		type,
		elements: [],
	};
}

export function createHighlights(sections: HighlightsSectionRequest[] = []): HighlightsContainerRequest {
	return {
		sections,
		meta: {
			name: '',
			width: 100,
		}
	};
}
